/**
 * Possible states for any Order
 */
export enum StateModel {
	Queued = 'Queued',
	UnderReview = 'UnderReview',
	Approved = 'Approved',
	Rejected = 'Rejected',
	ReOpen = 'ReOpen',
	RevisionReceived = 'RevisionReceived',
	Cancelled = 'Cancelled',
	NotReviewed = 'NotReviewed',
	PostRevisionReceived = 'PostRevisionReceived'
}

/**
 * Labeled State Status
 */
export enum StatusModel {
	Queued = 'Queued',
	UnderReview = 'In Quality',
	Approved = 'Approved',
	Rejected = 'Returned for Revision',
	ReOpen = 'In Quality',
	RevisionReceived = 'Revision Received',
	Cancelled = 'Cancelled'
}

export enum SSRFILTEROPTION {
	SSR = 'With SSR rules',
	NOSSR = 'Without SSR rules'
}

export enum SmartQCModel {
	NotEvaluated = 'Not Evaluated',
	InProgress = 'In Progress',
	AutoApproved = 'AutoApproved',
	ManualQCRequired = 'ManualQCRequired'
}

export const ORDERSTATES = [
	{ id: 1, name: StateModel.Queued },
	{ id: 2, name: StateModel.UnderReview },
	{ id: 3, name: StateModel.Rejected },
	{ id: 4, name: StateModel.RevisionReceived },
	{ id: 5, name: StateModel.Approved },
	{ id: 6, name: StateModel.ReOpen },
	{ id: 7, name: StateModel.Cancelled },
	{ id: 8, name: StateModel.NotReviewed },
	{ id: 9, name: StateModel.PostRevisionReceived}
];

// Default value for status orders
export const DEFAULTORDERSTATE = [
	{ id: 1, name: StateModel.Queued },
	{ id: 2, name: StateModel.UnderReview },
	{ id: 4, name: StateModel.RevisionReceived },
	{ id: 9, name: StateModel.PostRevisionReceived}
];

export const FILTERSSROPTIONS = [
	{ id: true, name: SSRFILTEROPTION.SSR },
	{ id: false, name: SSRFILTEROPTION.NOSSR }
];

export const FORMFILTERLIST = [
	{ id: 1, name: '1004' },
	{ id: 2, name: '1073' },
	{ id: 3, name: '1075' },
	{ id: 4, name: '2055' }
];

export enum SmartQCStatus {
	NotEvaluated = 0,
	Processing = 1,
	AutoApproved = 2,
	ManualQCRequired = 3,
}

export const SMARTQC_DISPLAY: Record<SmartQCStatus, string> = {
	[SmartQCStatus.NotEvaluated]: 'Not Evaluated',
	[SmartQCStatus.Processing]: 'In Progress',
	[SmartQCStatus.AutoApproved]: 'Auto Approved',
	[SmartQCStatus.ManualQCRequired]: 'Manual QC Required',
};

export interface SmartQCOption {
	id: SmartQCStatus;
	name: string;
}

export const SMARTQCLIST: SmartQCOption[] = [
	{ id: SmartQCStatus.NotEvaluated, name: SMARTQC_DISPLAY[SmartQCStatus.NotEvaluated] },
	{ id: SmartQCStatus.Processing, name: SMARTQC_DISPLAY[SmartQCStatus.Processing] },
	{ id: SmartQCStatus.AutoApproved, name: SMARTQC_DISPLAY[SmartQCStatus.AutoApproved] },
	{ id: SmartQCStatus.ManualQCRequired, name: SMARTQC_DISPLAY[SmartQCStatus.ManualQCRequired] },
];
